import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `font-mono text-xs ${isActive ? "text-brand" : "text-ink-muted hover:text-ink"}`;

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-full flex-col">
      <header className="border-b border-line/60 bg-surface-raised/60 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2">
            <span className="grid size-7 place-items-center rounded-md bg-brand font-mono text-sm font-bold text-brand-ink">
              O
            </span>
            <span className="text-sm font-semibold tracking-wide">OKTON BUILDER</span>
          </Link>

          <nav className="flex items-center gap-4">
            <NavLink to="/" className={linkClass} end>
              status
            </NavLink>
            {user ? (
              <>
                <NavLink to="/dashboard" className={linkClass}>
                  dashboard
                </NavLink>
                <NavLink to="/profile" className={linkClass}>
                  perfil
                </NavLink>
                <button onClick={handleLogout} className="font-mono text-xs text-ink-muted hover:text-ink">
                  sair
                </button>
              </>
            ) : (
              <NavLink to="/login" className={linkClass}>
                entrar
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-6 py-10">
        <Outlet />
      </main>

      <footer className="border-t border-line/60 px-6 py-4 text-center font-mono text-xs text-ink-muted">
        Laravel 12 · React · PostgreSQL 17 · Docker
      </footer>
    </div>
  );
}
